import React from 'react'

export const ParagraphComp = ({ children, text, className, onClick }) => {
    return (
        <p onClick={onClick} className={className}>
            {text} {children}
        </p >
    )
}
